import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { StepService } from 'src/app/services/step.service';
import { Subscription, combineLatest } from 'rxjs';
import { Router } from '@angular/router';
import { PolicyService } from 'src/app/services/policy.service';


@Component({
  selector: 'upsc-clms-banner',
  templateUrl: './clms-banner.component.html',
  styleUrls: ['./clms-banner.component.scss']
})
export class ClmsBannerComponent implements OnInit {
  @Input() currentStep: number;
  showBanner: boolean = false;
  private subscription: Subscription;
  isCLMS: boolean = false;

  constructor(
    private stepService: StepService,
    private router: Router,
    private policyService: PolicyService
  ) {}

  ngOnInit(): void {
    this.isCLMS = this.policyService.isCLMS();
    this.subscription = combineLatest([
      this.stepService.currentStep$,
      this.stepService.insured$
    ]).subscribe(([currentStep, insured]) => {
      if (currentStep == 3 && !insured && this.router.url.includes('claims/new') && this.isCLMS) {
        this.showBanner = true;
      } else {
        this.showBanner = false;
      }
    });
  }


  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeBanner(): void {
    this.showBanner = false;
  }
}
